import { Stack, Box } from "@mui/material"

import { SisetuResult } from 'interface/sisetu'

import { Loading } from "components/controls/loading"
import { ErrorBlock } from "components/controls/errorInfo"

import { useSisetuPreview } from './container'
import { SisetuPreviewHeader } from './components/header'
import { SisetuPreviewBody } from './components/body'
import { SisetuPreviewTabType } from './types'

import { SisetuPreviewDialog } from "features/sisetu/dialog/preview"
import { KojinPreviewDialog } from "features/kojin/dialog/preview"
import { ArticlePreviewDialog } from "features/article/dialog/preview"
import { TrialPreviewDialog } from "features/trial/dialog/preview"
import { ResearchPreviewDialog } from "features/research/dialog/preview"

type SisetuPreviewProps = {
  sisetuList?: SisetuResult[]
  sisetu?: SisetuResult
  sisetuCode?: string
  onSisetuOpen?: (sisetuCode: string | null) => void
  onKojinOpen?: (kojinCode: string | null) => void
  onAuthorOpen?: (authorId: number | null) => void
  defaultPage?: SisetuPreviewTabType | null
  onClose?: () => void
}
export const SisetuPreview = ({
  sisetuList,
  sisetu: defaultSisetu,
  sisetuCode: defaultSisetuCode,
  onSisetuOpen: onSisetuOpenReply,
  onKojinOpen: onKojinOpenReply,
  onAuthorOpen: onAuthorOpenReply,
  defaultPage,
  onClose
}: SisetuPreviewProps) => {
  const container = useSisetuPreview({
    sisetuList,
    defaultSisetu,
    defaultSisetuCode,
    onSisetuOpenReply,
    onKojinOpenReply,
    onAuthorOpenReply,
    onClose
  })
  const {
    loading, error, sisetu,
    /*onSisetuOpen,*/ selectedSisetuCode,
    /*onKojinOpen,*/ selectedKojinCode,
    /*onAuthorOpen,*/ selectedAuthorId,
    selectedArticleId, articleList,
    selectedTrialId, trialList,
    selectedProjectKey, projectList,
    closeModal
  } = container

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {loading && <Loading/>}
        <ErrorBlock error={error}/>

        {sisetu && (
          <Stack direction='column' sx={{
            height: '100%',
            maxHeight: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative'
          }}>
            <SisetuPreviewHeader sisetu={sisetu} container={container} flexShrink={0}/>
            <SisetuPreviewBody sisetu={sisetu} container={container} flexGrow={1} defaultPage={defaultPage ?? null}/>
          </Stack>
        )}
      </Box>

      {selectedSisetuCode ? (
        <SisetuPreviewDialog
          sisetuCode={selectedSisetuCode}
          onClose={closeModal}
        />
      ) : (selectedKojinCode || selectedAuthorId) ? (
        <KojinPreviewDialog
          kojinCode={selectedKojinCode}
          authorId={selectedAuthorId}
          onClose={closeModal}
        />
      ) : selectedArticleId ? (
        <ArticlePreviewDialog
          articleList={articleList}
          articleId={selectedArticleId}
          targetSisetuCode={sisetu?.sisetuCode}
          onClose={closeModal}
        />
      ) : selectedTrialId ? (
        <TrialPreviewDialog
          trialList={trialList}
          trialId={selectedTrialId}
          targetSisetuCode={sisetu?.sisetuCode}
          onClose={closeModal}
        />
      ) : selectedProjectKey ? (
        <ResearchPreviewDialog
          projectList={projectList}
          projectKey={selectedProjectKey}
          targetSisetuCode={sisetu?.sisetuCode}
          onClose={closeModal}
        />
      ) : <></>}
    </>
  )
}